import React, {FC, ReactNode} from 'react';
import {AutocompleteRenderGroupParams, createFilterOptions} from '@material-ui/lab';

import Subheader from '../game-select/Subheader';
import SearchInput from '../game-select/SearchInput';
import MultipleOption from '../game-select/MultipleOption';

import {AutocompleteListProps} from '../game-select/types';
import {Option} from '../../types';

import {StyledAutocomplete, InputContainer} from '../game-select/AutocompleteList.styles';

const WithoutWrappers: React.FC = ({children}: {children: ReactNode}) => <>{children}</>;

export interface PartialAutocompleteListProps extends Partial<AutocompleteListProps> {
    resultsLabel?: string;
}

const filterOptions = createFilterOptions<Option>({
    matchFrom: 'any',
    ignoreCase: true,
    stringify: option => option.label + option.value
});

const RadioAutocompleteList: FC<PartialAutocompleteListProps> = ({
    options,
    placeholder,
    resultsLabel,
    ...props
}: PartialAutocompleteListProps) => {
    const [search, setSearch] = React.useState<string>('');

    const handleSearchChange = (_event, value, reason) => {
        if (reason === 'input') {
            setSearch(value);
        }
    };

    const handleSearchReset = () => {
        setSearch('');
    };

    const optionsList = options.map(option => ({
        ...option,
        groupName: resultsLabel
    }));

    return (
        <StyledAutocomplete
            open
            multiple
            disableClearable
            clearOnBlur={false}
            getOptionLabel={({value}) => String(value)}
            getOptionSelected={(option, value) => String(option.value) === String(value.value)}
            PopperComponent={WithoutWrappers}
            PaperComponent={WithoutWrappers}
            filterOptions={filterOptions}
            inputValue={search}
            options={optionsList}
            groupBy={option => option.groupName}
            onInputChange={handleSearchChange}
            renderInput={({InputProps, inputProps}) => (
                <InputContainer ref={InputProps.ref}>
                    <SearchInput
                        {...inputProps}
                        search={search}
                        placeholder={placeholder}
                        onReset={handleSearchReset}
                    />
                </InputContainer>
            )}
            renderOption={(option, {selected}) => (
                <MultipleOption key={option.value} selected={selected} {...option} />
            )}
            renderGroup={(params: AutocompleteRenderGroupParams) => [
                params.group ? <Subheader {...params} /> : null,
                params.children
            ]}
            {...props}
        />
    );
};

export default RadioAutocompleteList;
